import { render, staticRenderFns } from "./shopWithdrawIndex.vue?vue&type=template&id=164eccc2&scoped=true"
import script from "./shopWithdrawIndex.vue?vue&type=script&lang=js"
export * from "./shopWithdrawIndex.vue?vue&type=script&lang=js"
import style0 from "./shopWithdrawIndex.vue?vue&type=style&index=0&id=164eccc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164eccc2",
  null
  
)

export default component.exports